import script from "./TressCheckoutCustomerDataForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCheckoutCustomerDataForm.vue?vue&type=script&lang=ts&setup=true"

import "./TressCheckoutCustomerDataForm.vue?vue&type=style&index=0&id=29f21736&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29f21736"]])

export default __exports__